## dummy for compile concat coffee files from common and here


#Swiper使用
$ ->
  main_swiper = new Swiper('.main-slider', {
    effect: 'fade',
    preventClicks: false,
    preventClicksPropagation: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    fade: {
      crossFade:true
    },
    parallax: true,
    speed: 1800,
    autoplay: true,
    loop: true,
    watchOverflow: true,
  })

  footer_swiper = new Swiper('.footer-bnr-slide', {
    effect: 'slide',
    slidesPerView: 4,
    slidesPerGroup: 2,
    centeredSlides: false,
    initialSlide: 0,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.footer-swiper-button-next',
      prevEl: '.footer-swiper-button-prev'
    },
    speed: 500,
    autoplay: true,
    loop: true
  })


  announce_swiper = new Swiper('.info-window', {
    effect: 'slide',
    slidesPerView: 1,
    slidesPerGroup: 1,
    speed: 1500,
    autoplay: true,
    loop: true
  })

#  raceinfo_history_swiper = new Swiper('.race-info-history', {
#    effect: 'slide',
#    slidesPerView: 3,
#    slidesPerGroup: 1,
#    centeredSlides: false,
#    initialSlide: 0,
#    speed: 500,
#    autoplay: true,
#    loop: true
#  })


$ ->
  $('input[required=required]').on('focusin', (e) ->
    $('.bagde-required').toggleClass('disappear')
  )

$ ->
  $('a[href^="#"]').on('click', ->
    time = 300
    target = $(this.hash)
    if (!target.length)
      return

    targetY = target.offset().top - 10
    $('html,body').animate({scrollTop: targetY}, time, 'swing')
    return false
  )

class MyTab
  basic: (btn, contents) ->
    opentab = "." + btn.attr('data-tab')
    btn.siblings().removeClass('active')
    btn.addClass('active')

    btn.siblings('.tab-direction').show()
    btn.next('.tab-direction').hide()
    btn.prev('.tab-direction').hide()

    contents.children('.active').removeClass('active')
    contents.children(opentab).addClass('active')


$ ->
  myTab = new MyTab

  $(".myTab").children('.tab-btn').on('click', ->
    myTab.basic($(this), $("." + $(this).parent().attr('data-tab-area')))
  )

  $(".myTab").children('.tab-direction').on('click', ->
    now = $(this).siblings('.active')
    if $(this).attr('data-direction') == 'prev'
      btn = now.prev('.tab-btn')
    else
      btn = now.next('.tab-btn')
    myTab.basic(btn, $("." + btn.parent().attr('data-tab-area')))
  )

  $(".select-race-num").on("change", ->
    $(".select-race-content").children('.active').removeClass('active')
    $(".select-race-content").children(".select-race-" + $(this).val()).addClass('active')
  )

  $(".race-number-item").on('click', ->
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    $(".race-main-info").removeClass((index, className) ->
      (className.match(/\btheme-\S+/g) || []).join(' '))
    $(".race-main-info").addClass('theme-' + $(this).attr('data-class')))

$ ->
  

$ ->
  $(".smart-nav-btn").on('click', ->
    $(this).toggleClass("active")
    $('#smart-nav').toggleClass("active")
  )

  $(".smart-subnav-btn").on('click', ->
    $(this).toggleClass("active")
    $(this).next('.smart-subnav').toggleClass("active")
  )


#キャラクタープロフィールのスライダー
$ ->
#ボタンをクリック
  $('.slide-btn').click ->
#テキスト内容を取得
    dis = $(this).html() - 1
    #コンテンツ位置までのアニメーション
    $('#character-sections').animate { 'left': dis * -300 + 'px' }, 300
    false
  return


#キャラクタープロフィール切り替え用
$ ->
  toggleChangeBtn = ->
# activeクラスがついている要素（現在表示中のスライド）のindexを取得
    slideIndex = $('.slide-content').index($('.slide-active'))
    console.log slideIndex
    #両ボタンを表示
    $('.s-btn').show()
    if slideIndex == 0
# prevボタンを隠す
      $('.prev').hide()
    else if slideIndex == $('.slide-content').length - 1
# nextボタンを隠す
      $('.next').hide()
    return

  toggleChangeBtn()
  $('.next').click ->
    $displaySlide = $('.slide-active')
    $displaySlide.removeClass 'slide-active'
    $displaySlide.next().addClass 'slide-active'
    toggleChangeBtn()
    # ボタンを隠すか判断
    return
  $('.prev').click ->
    $displaySlide = $('.slide-active')
    $displaySlide.removeClass 'slide-active'
    $displaySlide.prev().addClass 'slide-active'
    toggleChangeBtn()
    return
  return
